import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Container } from "@material-ui/core";
import { Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import appRoutes from "../../routes/app.routes";
import { fetchBlogArticle } from "../../services/blog.services";
import { BlogArticleDetail } from "./types";

const formatArticleDate = (date: string) => {
  if (!date) {
    return "";
  }

  const parsedDate = new Date(date.replace(" ", "T"));
  return Number.isNaN(parsedDate.getTime())
    ? date
    : parsedDate.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
};

const BlogArticle = () => {
  const { slug = "" } = useParams<{ slug: string }>();
  const [article, setArticle] = useState<BlogArticleDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadArticle = async () => {
      try {
        setLoading(true);
        setError("");
        setArticle(await fetchBlogArticle(slug));
      } catch {
        setError("This article is not available right now.");
      } finally {
        setLoading(false);
      }
    };

    loadArticle();
  }, [slug]);

  return (
    <main className="blog-article-page">
      {article && !error && (
        <Helmet>
          <title>{article.seo_title || `${article.title} | employHER Blog`}</title>
          <meta name="description" content={article.seo_description || article.excerpt || "Career advice and workplace insights from employHER."} />
        </Helmet>
      )}
      <Container fixed className="blog-article-page__container">
        <Link className="blog-article-page__back" to={appRoutes.blog.path}>
          <ArrowBackIcon fontSize="small" /> Back to Blog
        </Link>

        {loading && <p className="blog-article-page__message">Loading article...</p>}
        {!loading && error && <p className="blog-article-page__message">{error}</p>}

        {!loading && article && !error && (
          <article className="blog-article-detail">
            <header className="blog-article-detail__header">
              <span className="blog-category-label">{article.category}</span>
              <h1>{article.title}</h1>
              {article.excerpt && <p>{article.excerpt}</p>}
              <div className="blog-article-detail__meta">
                <span>{article.author || "employHER team"}</span>
                <span>{formatArticleDate(article.published_at)}</span>
              </div>
            </header>
            {article.cover_image && (
              <img className="blog-article-detail__image" src={article.cover_image} alt={article.title} />
            )}
            <div className="blog-article-detail__content" dangerouslySetInnerHTML={{ __html: article.content }} />
          </article>
        )}
      </Container>
    </main>
  );
};

export default BlogArticle;
